import { useMemo } from "react";

import { useQuery } from "@apollo/client";

import { type CreatorRewardRecord, CreatorRewardRecordEligibility } from "../../gql-generated/types";
import { type ApolloResult } from "../../shared/models";
import { creatorRewardRecord } from "../api/queries/creatorRewardRecord";
import {
    type CreatorRewardRecordQuery,
    type CreatorRewardRecordQueryVariables,
} from "../api/queries/creatorRewardRecord.gql-generated";

interface UseCreatorRewardsParams {
    lensId: string;
}
export const useCreatorRewardRecord = ({ lensId }: UseCreatorRewardsParams): ApolloResult<CreatorRewardRecord> => {
    const { data, loading, error } = useQuery<CreatorRewardRecordQuery, CreatorRewardRecordQueryVariables>(
        creatorRewardRecord,
        {
            skip: !lensId,
            variables: {
                lensId,
            },
        },
    );

    return useMemo(() => {
        return {
            loading,
            error,
            postUU: data?.creatorRewardRecord.postUU ?? 0,
            rewardEligibility:
                data?.creatorRewardRecord.rewardEligibility ?? CreatorRewardRecordEligibility.RewardEligibilityUnset,
        };
    }, [loading, error, data]);
};
